import React from 'react';
import FilterList from '../../../components/user/sector/sectorFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const SectorListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

SectorListPage.propTypes = {};

export default SectorListPage;
